//eslint-disable-next-line
import React, { useEffect, useState, useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { ArrowLeftOutlined, LeftOutlined } from '@ant-design/icons';
import { getQuestionById } from '../../redux/api/question';
import MainLayout from '../../components/MainLayout';
import SearchQuestion from '../../components/SearchQuestion/SearchQuestion';
import Question from '../../components/SearchQuestion/Question';
import HeaderInside from '../../components/HeaderInside';
import { Container, Panel, ButtonsStyled, ButtonStyled, ButtonStyledTwo } from './styles';
import Loading from 'components/Loading';
import { ROUTES } from '../../constants/routes';

function Questions() {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const { id } = useParams<{ id: string }>();
  const [data, setData] = useState({});

  const fetchData = useCallback(async (id) => {
    setLoading(true);
    try {
      const params = JSON.parse(localStorage.getItem('questionParams') || '{}');
      const questionData = await getQuestionById(id, params);
      setData(questionData);
    } catch (error) {
      // Error handled silently
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (id) {
      fetchData(id);
    }
  }, [id, fetchData]);

  return (
    <MainLayout title="Questões" className="home">
      <Container question={!!id}>
        {id ? (
          <ButtonsStyled>
            <ButtonStyled type="default" onClick={() => history.push(ROUTES.NEW_QUESTIONS)}>
              <ArrowLeftOutlined /> Voltar para Questões
            </ButtonStyled>
            <ButtonStyledTwo type="default" onClick={() => history.push(ROUTES.NEW_QUESTIONS)}>
              <LeftOutlined style={{ fontSize: '24px' }} />
            </ButtonStyledTwo>
          </ButtonsStyled>
        ) : (
          <HeaderInside
            title="Questões"
            subtitle="Pesquise pelo código, enunciado, módulo, família, capítulo e provas que a pergunta caiu. Suas respostas não serão salvas no banco de dados e não influenciarão nos seus relatórios :)"
          />
        )}
        <Panel>
          {loading ? (
            <Loading height="calc(100vh - 250px)" />
          ) : id ? (
            <Question data={data} resolved={false} />
          ) : (
            <SearchQuestion />
          )}
        </Panel>
      </Container>
    </MainLayout>
  );
}

export default Questions;
